// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0db122f","455":"f898f940","977":"f13384bd"}[chunkId] + ".chunk.js";
};